import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { DateTime } from 'luxon'
import VehicleTypeIcon from '@/components/VehicleTypeIcon.vue'
import {
  currencyFilter,
  pluralize,
  toTitle,
} from '@/utils/string'
import { EventBus } from '@/utils/eventBus'
import ReservationSummary from '@/models/dto/reservationSummary/ReservationSummary'
import { ReservationStatusKey } from '@/utils/enum'

interface Props {
  row: ReservationSummary
  uuid: string
  selectedReservationIds: number[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReservationSummaryMobileCard',
  props: {
    row: { default: null },
    uuid: null,
    selectedReservationIds: null
  },
  setup(__props: any, { emit }: { emit: ({
  click: []
}), expose: any, slots: any, attrs: any }) {

const props = __props as { row: ReservationSummary, uuid: string, selectedReservationIds: number[] };





const selected = computed(() => props.selectedReservationIds.includes(props.row.id))

const tripType = computed(() => toTitle(props.row.tripType))

const reservationStatus = computed(() => {
  const tripStatus = props.row.tripStatus === ReservationStatusKey.OnHold
    ? ReservationStatusKey.Upcoming
    : props.row.tripStatus
  return toTitle(tripStatus)
})

const vehicles = computed(() => {
  const vehicles = props.row.vehicles
  if (!vehicles) {
    return ''
  }
  if (vehicles.length > 1) {
    const totalVehicleCount = vehicles.reduce(
      (sum, vehicle) => sum + vehicle.quantity,
      0
    )
    return `${totalVehicleCount} Vehicles`
  }
  const quantity = vehicles[0].quantity
  const label = vehicles[0].label
  return `${quantity} ${pluralize(quantity, label)}`
})

const passengerCount = computed(() => props.row.passengerCount || null)

const pickupDate = computed(() => {
  const pickupDatetime = props.row.pickupDatetime
  const pickupTimezone = props.row.pickupTimezone
  if (!pickupDatetime || !pickupTimezone) {
    return ''
  }
  return DateTime.fromISO(pickupDatetime, { zone: pickupTimezone }).toFormat('MM/dd/yy')
})

const pickupTime = computed(() => {
  const pickupDatetime = props.row.pickupDatetime
  const pickupTimezone = props.row.pickupTimezone
  if (!pickupDatetime || !pickupTimezone) {
    return ''
  }
  return DateTime.fromISO(pickupDatetime, { zone: pickupTimezone }).toFormat('h:mm a')
})

const displayPrice = computed(() => {
  if (!props.row.price) {
    return ''
  }
  return currencyFilter(props.row.price)
})

const paymentStatus = computed(() => toTitle(props.row.paymentStatus))

const displayVehicleType = computed(() => props.row.vehicles?.[0]?.label || null)

const handleSelectClick = (value: boolean): void => {
  EventBus.$emit(`toggle-select-item-${props.uuid}`, {
    key: props.row.id,
    value,
  })
}

return { __sfc: true,props, emit, selected, tripType, reservationStatus, vehicles, passengerCount, pickupDate, pickupTime, displayPrice, paymentStatus, displayVehicleType, handleSelectClick, VehicleTypeIcon }
}

})